// eslint-disable-next-line @harmony/stencil/no-tailwind-disable
/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable @harmony/stencil/no-import-css */
import React, { FC } from 'react';
import '../styles/styles.scss';

export interface LoadingSpinnerProps {
  ariaLabel?: string;
  className?: string;
  testId?: string;
}

/**
 * LoadingSpinner component with enhanced accessibility features
 *
 * @param ariaLabel - Text announced to screen readers (default: "Loading, please wait...")
 * @param className - Additional CSS classes for styling
 * @param testId - Test identifier for testing purposes
 */
export const LoadingSpinner: FC<LoadingSpinnerProps> = ({
  ariaLabel = 'Loading, please wait...',
  className = '',
  testId = 'loading-spinner'
}) => {
  return (
    <div
      className={`loading-container ${className}`.trim()}
      role="status"
      aria-live="polite"
      data-testid={`${testId}-container`}
    >
      <div
        className="loading-spinner"
        aria-label={ariaLabel}
        data-testid={testId}
      />
      <span className="sr-only">{ariaLabel}</span>
    </div>
  );
};
